import { components } from "@/api-schema";
import { UserStatus, UserType } from "@/api-schema-enums";

type User = components["schemas"]["User"];

export function userIsEditableGuest(user?: Pick<User, "type" | "status"> | null): boolean {
  return user?.type === UserType.Guest && user.status === UserStatus.Enabled;
}
